import { ref, onUnmounted } from '@vue/composition-api'
export const useCountDown = (inittime = 60) => {
  const time = ref(inittime)
  let timeId
  const start = () => {
    time.value = inittime
    timeId = setInterval(() => {
      if (time.value > 0) {
        time.value--
      }

      if (time.value <= 0) {
        clearInterval(timeId)
      }
      if (time.value < 0) {
        time.value = 0
      }
    }, 1000)
  }
  const end = () => {
    if (timeId) {
      clearInterval(timeId)
    }
  }

  onUnmounted(() => {
    clearInterval(timeId)
  })
  return { time, start, end }
}
